import moment, { Moment } from 'moment';
import { i18n } from '@/i18n';
/**
 * ViewModelの規定クラス
 */
export abstract class ViewModel {
  public viewText = (value?: string | number, emptyText?: string): string => {
    if (value && typeof value == 'number') {
      return String(value);
    } else if (value && typeof value == 'string') {
      return value;
    }
    return emptyText || '-';
  };

  public toDateString = (date?: Moment): string => {
    return date ? date.format('YYYY-MM-DD') : '-';
  };

  public formatStringJa = (date?: Moment): string => {
    return date ? date.format('YYYY年MM月DD日') : '-';
  };

  public formatDateTimeString = (date?: Moment): string => {
    return date ? date.format('YYYY/MM/DD HH:mm') : '-';
  };

  public toDateStringJa = (date: Date) => {
    return this.formatStringJa(moment(date));
  };

  // {year, month, day}のオブジェクトをYYYY/MM/DDに変換
  public objectToDateString = (date: Date) => {
    return this.toDateString(moment(date));
  };

  // 様々なページで使うので例外的にindex.tsで定義
  public getForecastLabel = (index: number) => {
    const date = new Date();
    const i18nKey = `${((date.getMonth() + index) % 12) + 1}月内示`;
    return i18n.t(i18nKey);
  };
}
